'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubmersibleIcon = function SubmersibleIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#FFF'
                },
                _react2.default.createElement('path', {
                    d: 'M48.455 57.594H83v9.491H48.455zM48.455 71.068H83V96.62H48.455z'
                }),
                _react2.default.createElement('path', {
                    d: 'M53.6 67.418h24.255v3.65H53.6zM57.845 49h14.7v9.491h-14.7zM53.6 95.16h8.82V101H53.6zM69.035 95.16h8.82V101h-8.82zM38 81.161h5.88v4.38H38z'
                })
            ),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M54.133 69.722h23.091v-2.207h-23.09v2.207zm-4.642 20.38v-19.05h32.376v23.814H49.49v-4.763zm20.187 9.155h7.546v-3.061h-7.546v3.06zm-15.647 0h7.806v-3.061H54.03v3.06zm-6.087-33.948v2.205h4.434v2.208l-4.39-.052v2.205l.092 24.267 4.311.054v4.412h11.084v-4.412h4.435v4.412h11.084v-4.412h4.419V69.722H78.98v-2.208h4.433v-11.03H47.944v8.825zm1.547.69h32.377v-8H49.491v8z',
                    stroke: '#555',
                    strokeWidth: '.5'
                }),
                _react2.default.createElement('path', {
                    d: 'M74.336 56.548l-1.834-.004.015-6.279c0-.168-.672-.555-1.657-.562l.013-1.823c1.863.013 3.488.95 3.478 2.394l-.015 6.274z',
                    fillRule: 'nonzero'
                }),
                _react2.default.createElement('path', {
                    d: 'M70.87 47.88l-.008 1.822-10.314-.052c-.986-.006-1.664.372-1.665.54l-.033 6.274-1.834-.01.033-6.276c.01-1.448 1.647-2.363 3.51-2.35l10.312.052zM39.533 71.473h1.834v8.957h-1.834z',
                    fillRule: 'nonzero'
                }),
                _react2.default.createElement('path', {
                    d: 'M41.38 71.874c0-9.998 1.146-16.009 3.374-19.16 1.74-2.46 3.988-3.216 8.21-3.216 2.004 0 3.61.445 4.867 1.274l1.014-1.519c-1.569-1.035-3.53-1.577-5.881-1.577-9.8 0-13.417 5.114-13.417 24.198h1.834zM42.173 84.61a.5.5 0 0 0 .494-.508v-1.998a.5.5 0 0 0-.494-.507h-2.952a.5.5 0 0 0-.493.507v1.998a.5.5 0 0 0 .493.507h2.952zm0 1.822h-2.952a2.329 2.329 0 0 1-2.327-2.33v-1.998c0-1.285 1.04-2.33 2.327-2.33h2.952a2.328 2.328 0 0 1 2.327 2.33v1.998c0 1.284-1.04 2.33-2.327 2.33zM72.012 71.052h1.834V89.78h-1.834zM72.012 91.152h1.834v4.585h-1.834z',
                    fillRule: 'nonzero'
                }),
                _react2.default.createElement('path', {
                    fillRule: 'nonzero',
                    d: 'M48.794 62.91v-1.822h27.56v1.823zM77.733 62.683v-1.367h4.134v1.367z'
                })
            ),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M83.01 31.154v-2.308h24.144v72.308H24.846V28.846h23.072v2.308H27.154v67.692h77.692V31.154z'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M111.846 24.154H83.01v-2.308h31.144v86.308H16.846V21.846h31.072v2.308H19.154v81.692h92.692z'
            }),
            _react2.default.createElement(
                'g',
                {
                    stroke: '#555',
                    strokeWidth: '2.1'
                },
                _react2.default.createElement('path', {
                    d: 'M87.395 39.401H26.3M105.163 39.401h-5.578M96.348 39.401H90.77'
                })
            )
        )
    );
};

SubmersibleIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Submersible = function (_React$Component) {
    _inherits(Submersible, _React$Component);

    function Submersible() {
        _classCallCheck(this, Submersible);

        return _possibleConstructorReturn(this, (Submersible.__proto__ || Object.getPrototypeOf(Submersible)).apply(this, arguments));
    }

    _createClass(Submersible, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(SubmersibleIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return Submersible;
}(_react2.default.Component);

exports.default = Submersible;